import { BaseModel } from './base.model'
import { Role, UserRole } from './role.model'
import { Team } from './team.model'
import { Timezone } from './timezone.model'

export class Reseller extends BaseModel {
  id: number
  companyName: string
  keyContact: ResellerUser
  status: ResellerStatuses
  address: string
  currency: string
  timezone: Timezone
  logo: string
  domain: string
  units: string
  phone: string
  emailName: string
  team: Team
  billingAddress: string
  legalAddress: string
  legalName: string
  taxNr: string
  chevronAccountId: string
  picture: string
  fullName: string
  createdAt: string
  updatedAt: string
  updatedBy: ResellerUpdatedBy
  createdByName: string
  manager: ResellerManager
  salesManager: ResellerManager
  language: string

  get updatdeByFullName(): string {
    return this.updatedBy ? `${this.updatedBy.name} ${this.updatedBy.surname}` : ''
  }

  get managerFullName(): string {
    return this.manager ? `${this.manager.name} ${this.manager.surname}` : ''
  }

  get salesFullName(): string {
    return this.salesManager ? `${this.salesManager.name} ${this.salesManager.surname}` : ''
  }

  constructor(reseller: Partial<Reseller>) {
    super(reseller)
  }
}

export class ResellerUser extends BaseModel {
  id: string
  email: string
  phone: string
  status: string
  team: Team
  timezone: Timezone
  surname: string
  name: string
  blockingMessage: string
  createdAt: string
  createdById: string
  createdByName: string
  driverId: string
  driverSensorId: string
  is2FaEnabled: boolean
  isPhoneVerified: boolean
  isBlocked: boolean
  lastLoggedAt: string
  managedTeams: null
  picture: null
  position: null
  role: UserRole
  roleId: number
  teamType: string
  updatedAt: string
  last_logged_at: string
  language: string
  userGroups: []
  isSSO?: boolean

  get fullName(): string {
    return `${this.name} ${this.surname}`
  }

  constructor(resellerUser: Partial<ResellerUser>) {
    super(resellerUser)
  }
}

export enum ResellerStatuses {
  Active = 'active',
  Blocked = 'blocked',
  Deleted = 'deleted',
}

export interface ResellerUpdatedBy {
  driverSensorId: string | number
  email: string
  id: string
  lastLoggedAt: string
  name: string
  phone: string
  role: Pick<Role, 'id' | 'name' | 'displayName'>
  status: string
  surname: string
}

export interface ResellerManager {
  driverSensorId: null
  email: string
  id: string
  lastLoggedAt: string
  name: string
  phone: string
  role: Pick<Role, 'id' | 'name' | 'displayName'>
  status: string
  surname: string
}
